"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarehouseWorkflowSourceType = void 0;
exports.WarehouseWorkflowSourceType = {
    REPLENISHMENT: "REPLENISHMENT",
    BOPIS: "BOPIS",
    RETURNS: "RETURNS",
};
//# sourceMappingURL=warehouse-workflow-source-type.js.map